import { Link } from "react-router-dom"


export default function ClientsCard({_id, id, contactName, email, lastName, name, nameCompany, notes, telephoneNumber, address, city}){

    return(
        <div className="flex">
            <div className="flex border-b border-slate-500">
                <Link to={`/clientes/${_id}`}>
            <div key={_id} className="flex text-[11px] hover:font-bold pt-2 text-sky-200 hover:text-orange-400">                
                <div className="pl-2 w-12 text-center">
                    <p className="">{id}</p>
                </div>
                <div className="pl-3 w-[263px]">
                <p className="">{nameCompany}</p>
                </div>
                <div className="w-32">
                    <p className="">{lastName}</p>
                </div>
                <div className="w-32">
                    <p className="">{name}</p>                    
                </div>
                <div className="w-40">
                    <p className="">{address}</p>
                </div>
                <div className="w-32">
                    <p className="">{city}</p>
                </div>
                <div className="w-48">
                    <p className="">{telephoneNumber}</p>
                </div>
                {/* <div>
                    <p>{contactName}</p>
                </div>
                <div>
                    <p>{email}</p>
                </div>
                <div>
                    <p>{notes}</p>
                </div> */}
            </div>
                </Link>
                </div>
        </div>
    )
}